import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

export const createAndSaveWorkbookMerge = (datas, filename) => {
    const workbook = XLSX.utils.book_new();
    const worksheet = createWorksheet([]);

    let startRow = 1;

    datas.forEach((data, index) => {
        if (data.title) {
            XLSX.utils.sheet_add_aoa(worksheet, [[data.title]], { origin: `A${startRow}` });
            startRow += 2; // Pula uma linha após o título
        }

        XLSX.utils.sheet_add_aoa(worksheet, data, { origin: `A${startRow}` });
        startRow += data.title ? data.length + 2 : data.length + 1; // Pula linhas após os dados da tabela
    });

    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, filename);
}

export const createAndSaveWorkbook = (datas, filename) => {
    const workbook = XLSX.utils.book_new();

    datas.forEach((data, index) => {
        const worksheet = XLSX.utils.aoa_to_sheet(data);
        XLSX.utils.book_append_sheet(workbook, worksheet, `Sheet${index + 1}`);
    });

    XLSX.writeFile(workbook, filename);
}

export const exportExcelToJson = (dataJson, excelName) => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.shee;charset=UTF-8';
    const fileExtension = '.xlsx';
    const ws = XLSX.utils.json_to_sheet(dataJson);
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, excelName + fileExtension);
}

export const createWorksheet = (data) => XLSX.utils.aoa_to_sheet(data);

export const createSheetToJson = (params) => {
    const data = [];
    const header = Object.keys(params[0]);
    data.push(header);

    params.forEach(item => {
        const array = []
        header.forEach(element1 => {
            array.push(item[element1])
        });
        data.push(array);
    });
    return data;
}
